import {ChangeDetectionStrategy, Component, HostBinding, inject, input, signal} from '@angular/core';
import {Divider} from "primeng/divider";
import {FooterComponent} from "../footer/footer.component";
import {TryReasonComponent} from "../../pages/landing-page/try-reason/try-reason.component";
import {SignupButtonComponent} from "../signup-button/signup-button.component";
import {initialSignupRoute} from "../../pages/signup/specific-signup.routes";
import {FormsModule} from "@angular/forms";
import {Button} from "primeng/button";
import {MessageService} from "primeng/api";
import {InputText} from "primeng/inputtext";
import {EmailListService} from "../../services/email-list.service";
import {UserService} from "../../services/user.service";
import {ABService} from "../../services/a-b.service";
import {RouterLink} from "@angular/router";
import {TranslocoPipe} from "@jsverse/transloco";

@Component({
  selector: 'homey-full-footer',
  imports: [
    Divider,
    FooterComponent,
    TryReasonComponent,
    SignupButtonComponent,
    FormsModule,
    Button,
    InputText,
    RouterLink,
    TranslocoPipe
  ],
  templateUrl: './full-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FullFooterComponent {
  @HostBinding('class') class = 'flex flex-col';
  public readonly messageService = inject(MessageService);
  public readonly userService = inject(UserService);
  public readonly abService = inject(ABService);
  public readonly emailListService = inject(EmailListService);
  public readonly showLogin = input(false);
  public readonly defaultSignupRoute = input<string[]>(initialSignupRoute);
  protected readonly signupState = this.userService.signupState;
  protected readonly footerStyle = this.abService.footerStyle;

  public readonly email = signal("");

  public onEmailSubmit() {
    if (!this.email().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      this.messageService.add({severity: 'error', summary: 'Invalid email', detail: 'Please enter a valid email address.'});
      return;
    }

    this.emailListService.addToEmailList(
      this.email(),
    ).subscribe(() => {
      this.messageService.add({severity: 'success', summary: 'Subscribed', detail: `${this.email()} has been subscribed to our lottery updates!`, life: 10000});
      this.email.set("");
    });
  }
}
